import { useDogxContext } from '@libs/dogx';
import { routes } from '@libs/renegkit/routes';

export const RK_HOME_EXPERIMENT = 'dx-rk-offers-listing';
export const RK_HOME_VARIANT = 'rk-offers';

export const useRKOffersListingExperiment = () => {
  const { getExperimentVariant } = useDogxContext();
  const variant = getExperimentVariant(RK_HOME_EXPERIMENT) ?? 'control';
  const isRKOffersListingVariant = variant === RK_HOME_VARIANT;

  return {
    variant,
    isRKOffersListingVariant,
  };
};

const getDogxVariantFromCookie = (name: string): string | undefined => {
  const cookie = document.cookie.split(';').find((c) => c.trim().startsWith(`${name}=`));
  return cookie ? cookie.trim().split('=')[1]?.split(':')[0] : undefined;
};

export const getHomePath = () => (getDogxVariantFromCookie(RK_HOME_EXPERIMENT) === RK_HOME_VARIANT ? routes.home.path : '/minhas-dividas');
